import { CLEAR_SYSTEM_CACHE } from "../../session/type";
import { GET_NEWS_LIST_SUCCEEDED, GET_NEWS_LIST_FAILED } from "./type";

interface News {
  id: number;
  title: string;
  content: string;
  status: number;
  priority: number;
  views: number;
  read: boolean;
  released_at: Date;
  created_at: Date;
  updated_at: Date;
}

const initialState: News[] = [];

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_NEWS_LIST_SUCCEEDED:
      return [...action.news];

    case GET_NEWS_LIST_FAILED:
      return {
        ...state,
        message: action.message,
      };

    case CLEAR_SYSTEM_CACHE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
